<template>
    <div v-if="!isMobileOrTablet" class="tw-hidden md:tw-inline-block tw-font-sans tw-text-xxs">
        <slot name="prefix" />
        <span class="tw-font-bold">{{ combinedKeyString }}</span>
        <slot name="postfix" />
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    props: {
        keys: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            mapping: Object.freeze({
                enter: `Enter ↵`,
                shift: `Shift ⇧`,
                leftArrow: `Left Arrow ←`,
            }),
        };
    },
    computed: {
        ...mapGetters({
            isMobileOrTablet: "isMobileOrTablet",
        }),
        combinedKeyString() {
            if (!Array.isArray(this.keys)) return "";

            return this.keys
                .map(key => this.mapping[key] ?? null)
                .filter(Boolean)
                .join(" + ");
        },
    },
};
</script>
